import { IResponseError } from "../web-request-factory/interfaces/IResponseError";
import { ResponseError } from "./ResponseError";

export function fromStatusCodeToGenericError(errorResponse: Response): Promise<IResponseError> {
    return Promise.resolve(new ResponseError(errorResponse.status.toString()));
}
